/* NgRx */
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {MetricsState} from './metrics.reducer';

// Selector functions
const metricsPageData =
  createFeatureSelector<MetricsState>('ss-cord.metrics');

// Create Selectors
export const metricsData = createSelector(
  metricsPageData,
  (state: MetricsState) => state.metricsData
);

// Get Metrics List
export const metricsOptions = createSelector(
  metricsPageData,
  (state: MetricsState) => state.metricsOptions
);

